// import MeetingItem from '../../components/meetingItem';


// import './style.scss';
// import {useEffect, useState} from "react";
// import {getMeetingsByGroup} from "../../API/apiService";
// import { useLocation} from "react-router-dom";

// function MeetingsList() {

//     // HOOKS
//     const location = useLocation();
//     const receivedGroup = location.state?.group;
//     const receivedSchool = location.state?.school;
//     const receivedBackTo = location.state?.backTo;
//     const [meetings, setMeetings] = useState([]);
//     const groupId =
//         typeof receivedGroup === 'object' && receivedGroup !== null
//             ? receivedGroup?.id
//             : receivedGroup;
//     const meetingListState = {
//         group: receivedGroup,
//         school: receivedSchool,
//         backTo: receivedBackTo
//     };
//     async function getInfo(targetGroupId){
//         if(targetGroupId) {
//             const m = await getMeetingsByGroup(targetGroupId);
//             setMeetings(m);
//         }
//     }

//     useEffect(() => {
//         getInfo(groupId)
//     }, [groupId]);
//     return (
//         <section className='meetings'>
//             <div className='meetings__main group'>
//                 <div className='group__info info'>
//                     <div className='info__icon icon'>
//                         <span className='material-symbols-rounded icon__img'>school</span>
//                     </div>
//                     <span className='info__title'>Tomar asistencia</span>
//                     <span className='info__value'>Lista de Encuentros</span>
//                 </div>

//             </div>

//             <div className='meetings__details'>
//                 {meetings && meetings?.length > 0 &&
//                     meetings.map((meeting, i) => (
//                         <MeetingItem key={i} meeting={meeting} listState={meetingListState}/>
//                     ))}
//             </div>
//         </section>
//     );
// }

// export default MeetingsList;


import MeetingItem from '../../components/meetingItem';
import './style.scss';
import { useEffect, useMemo, useState } from "react";
import {
  addGroupSession,
  addControlSocialGroupSession,
  createPublicAttendanceQrToken,
  finishControlSocialGroup,
  finishSchoolGroup,
  getMeetingsByActivityGroup,
  getMeetingsByGroup
} from "../../API/apiService";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import QrCode from '../../components/qrCode';
import { isGroupCancelled, isGroupFinished } from '../../utils/groupStatus';
import { matchesSchoolByAdminScope } from '../../utils/adminScope';
import SocialControlMeetings from './socialControlMeetings';
import { getResultsLog } from '../../API/resultsLog';

function StandardMeetingsList({socialControlContext = null}) {
  const location = useLocation();
  const navigate = useNavigate();
  const receivedGroup =
    socialControlContext?.group || location.state?.group;
  const receivedSchool =
    socialControlContext ? null : location.state?.school;
  const receivedBackTo = location.state?.backTo;

  const [meetings, setMeetings] = useState([]);
  const [qrInfo, setQrInfo] = useState(null);
  const [isGeneratingQr, setIsGeneratingQr] = useState(false);
  const [isAddingSession, setIsAddingSession] = useState(false);
  const [isFinishingGroup, setIsFinishingGroup] = useState(false);
  const [showFinishConfirmation, setShowFinishConfirmation] = useState(false);
  const [isCheckingResultsLog, setIsCheckingResultsLog] = useState(false);
  const [resultsLogConfirmed, setResultsLogConfirmed] = useState(false);
  const [finalizationConfirmed, setFinalizationConfirmed] = useState(false);
  const [groupStatus, setGroupStatus] = useState(
    typeof receivedGroup === 'object' && receivedGroup !== null
      ? receivedGroup?.status ?? receivedGroup?.group_status ?? ''
      : ''
  );
  const [showQrTimeModal, setShowQrTimeModal] = useState(false);
  const [scheduleAction, setScheduleAction] = useState('qr');
  const [selectedScheduleMeetingIds, setSelectedScheduleMeetingIds] = useState([]);

  useEffect(() => {
    if (!qrInfo?.url) return undefined;

    document.body.classList.add('modal-open');
    return () => document.body.classList.remove('modal-open');
  }, [qrInfo?.url]);

  const groupId =
    socialControlContext
      ? null
      : typeof receivedGroup === 'object' && receivedGroup !== null
        ? receivedGroup?.id
        : receivedGroup;
  const activityGroupId = socialControlContext?.group?.id || null;

  const currentGroup = useMemo(() => {
    if (typeof receivedGroup !== 'object' || receivedGroup === null) {
      return groupStatus
        ? { id: receivedGroup, status: groupStatus }
        : receivedGroup;
    }

    return {
      ...receivedGroup,
      status: groupStatus
    };
  }, [receivedGroup, groupStatus]);

  const meetingListState = useMemo(() => ({
    group: currentGroup,
    school: receivedSchool,
    backTo: receivedBackTo,
    controlSocialContext: Boolean(socialControlContext),
    activity: socialControlContext?.activity || null,
    activityGroup: socialControlContext?.group || null
  }), [
    currentGroup,
    receivedSchool,
    receivedBackTo,
    socialControlContext
  ]);

  const schoolId =
    typeof receivedSchool === 'object' && receivedSchool !== null
      ? receivedSchool?.id
      : receivedSchool ??
        currentGroup?.schoolId ??
        currentGroup?.school_id ??
        currentGroup?.school?.id;

  const groupCancelled = isGroupCancelled(currentGroup);
  const groupFinished = isGroupFinished(currentGroup);
  const groupClosed = groupCancelled || groupFinished;
  const hasGroupContext = Boolean(
    activityGroupId || (groupId && schoolId)
  );
  const resultsLogSchool =
    (typeof receivedSchool === 'object' && receivedSchool !== null
      ? receivedSchool
      : currentGroup?.school) || { code: currentGroup?.code };
  const canOpenResultsLog = !socialControlContext && hasGroupContext && (
    matchesSchoolByAdminScope(resultsLogSchool, 'pf') ||
    matchesSchoolByAdminScope(resultsLogSchool, 'ndn')
  );

  const batchCharacterizationState = useMemo(() => ({
    ...meetingListState,
    meetings,
    attendanceBatch: true,
    backTo: {
      pathname: '/escuelas/grupo/lista_de_encuentros',
      state: meetingListState
    }
  }), [meetingListState, meetings]);

  const qrMeetingIds = useMemo(() => {
    return meetings
      .filter(meeting => meeting?.type === 'MEETING')
      .slice()
      .sort((a, b) => Number(a?.order ?? 0) - Number(b?.order ?? 0))
      .map(meeting => meeting.id)
      .filter(Boolean);
  }, [meetings]);

  const scheduleMeetings = useMemo(() => (
    meetings
      .filter(meeting => meeting?.type === 'MEETING')
      .slice()
      .sort((a, b) => Number(a?.order ?? 0) - Number(b?.order ?? 0))
  ), [meetings]);

  function normalizePublicQrUrl(value) {
    const rawValue = String(value || '').trim();
    if (!rawValue) return '';

    try {
      return new URL(rawValue, window.location.origin).href;
    } catch (error) {
      return '';
    }
  }

  function handleOpenTimeModal(action = 'qr') {
    setScheduleAction(action);
    setSelectedScheduleMeetingIds([]);
    setShowQrTimeModal(true);
  }

  function toggleScheduleMeeting(meetingId) {
    setSelectedScheduleMeetingIds((currentIds) => (
      currentIds.includes(meetingId)
        ? currentIds.filter(id => id !== meetingId)
        : [...currentIds, meetingId]
    ));
  }

  async function handleGenerateQr(event) {
    event?.preventDefault();
    if (!hasGroupContext) return;

    if (selectedScheduleMeetingIds.length === 0) {
      toast('Selecciona al menos un encuentro', { type: 'warning' });
      return;
    }

    setIsGeneratingQr(true);
    try {
      const response = await createPublicAttendanceQrToken({
        ...(activityGroupId
          ? {activityGroupId}
          : {groupId, schoolId}),
        meetingIds: selectedScheduleMeetingIds
      });

      if (!response?.token) {
        return;
      }

      const publicUrl =
        normalizePublicQrUrl(response.url) ||
        `${window.location.origin}/registro-jornada?token=${encodeURIComponent(response.token)}`;
      setQrInfo({
        url: publicUrl,
        title: 'QR de caracterizacion y asistencia',
        expiresAt: response.expiresAt
      });
      setShowQrTimeModal(false);
    } finally {
      setIsGeneratingQr(false);
    }
  }

  async function handleScheduleSubmit(event) {
    if (scheduleAction === 'qr') {
      await handleGenerateQr(event);
      return;
    }

    event?.preventDefault();
    if (selectedScheduleMeetingIds.length === 0) {
      toast('Selecciona al menos un encuentro', { type: 'warning' });
      return;
    }

    const selectedMeetings = meetings.filter(meeting => (
      selectedScheduleMeetingIds.includes(Number(meeting.id))
    ));
    setShowQrTimeModal(false);
    navigate(
      activityGroupId
        ? `/caracterizacion-jornada/control-social/group/${activityGroupId}`
        : `/caracterizacion-jornada/school/${schoolId}/group/${groupId}`,
      { state: { ...batchCharacterizationState, meetings: selectedMeetings } }
    );
  }

  async function handleGenerateCharacterizationQr() {
    if (!hasGroupContext || isGeneratingQr) return;

    setIsGeneratingQr(true);
    try {
      const response = await createPublicAttendanceQrToken({
        ...(activityGroupId
          ? {activityGroupId}
          : {groupId, schoolId}),
        registrationMode: 'characterization_only'
      });

      if (!response?.token) return;

      const publicUrl =
        normalizePublicQrUrl(response.url) ||
        `${window.location.origin}/registro-jornada?token=${encodeURIComponent(response.token)}`;
      setQrInfo({
        url: publicUrl,
        title: 'QR de caracterizacion',
        expiresAt: response.expiresAt
      });
    } finally {
      setIsGeneratingQr(false);
    }
  }

  async function copyQrLink() {
    if (!qrInfo?.url) return;

    try {
      await navigator.clipboard.writeText(qrInfo.url);
      toast('Enlace copiado', {
        type: 'success'
      });
    } catch (error) {
      toast('No se pudo copiar el enlace', {
        type: 'warning'
      });
    }
  }

  async function handleAddSession() {
    if (
      (!groupId && !activityGroupId) ||
      groupClosed ||
      isAddingSession
    ) return;

    setIsAddingSession(true);
    try {
      const newMeeting = activityGroupId
        ? await addControlSocialGroupSession(activityGroupId)
        : await addGroupSession(groupId);
      if (!newMeeting) return;

      setMeetings((currentMeetings) => (
        [...currentMeetings, newMeeting].sort((left, right) => {
          const typeComparison = String(right?.type || '').localeCompare(String(left?.type || ''));
          if (typeComparison !== 0) return typeComparison;
          return Number(left?.order || 0) - Number(right?.order || 0);
        })
      ));
      toast(`Encuentro ${newMeeting.order} agregado`, { type: 'success' });
    } finally {
      setIsAddingSession(false);
    }
  }

  async function openFinishConfirmation() {
    if (!hasGroupContext || groupClosed || isFinishingGroup || isCheckingResultsLog) return;
    setResultsLogConfirmed(false);
    setFinalizationConfirmed(false);
    if (canOpenResultsLog) {
      setIsCheckingResultsLog(true);
      try {
        const data = await getResultsLog(groupId);
        const hasContent = ['initialObservations', 'socioculturalReflection', 'transformationObservations']
          .some(field => String(data?.log?.[field] || '').trim().length > 0);
        if (!hasContent) {
          toast('Debe guardar contenido en la bitácora de resultados antes de finalizar el grupo', { type: 'warning' });
          return;
        }
      } catch (_) {
        toast('No se pudo verificar la bitácora de resultados. Inténtelo de nuevo.', { type: 'error' });
        return;
      } finally {
        setIsCheckingResultsLog(false);
      }
    }
    setShowFinishConfirmation(true);
  }

  async function handleFinishGroup() {
    if (!hasGroupContext || groupClosed || isFinishingGroup) return;
    if (canOpenResultsLog && (!resultsLogConfirmed || !finalizationConfirmed)) return;

    setIsFinishingGroup(true);
    try {
      const finished = activityGroupId
        ? await finishControlSocialGroup(activityGroupId)
        : await finishSchoolGroup(groupId, schoolId, { resultsLogConfirmed, finalizationConfirmed });
      if (!finished) return;

      setGroupStatus('FINALIZADO');
      setShowFinishConfirmation(false);
      toast('Grupo finalizado', { type: 'success' });
    } finally {
      setIsFinishingGroup(false);
    }
  }

  useEffect(() => {
    let alive = true;

    (async () => {
      if (!groupId && !activityGroupId) return;
      const m = activityGroupId
        ? await getMeetingsByActivityGroup(activityGroupId)
        : await getMeetingsByGroup(groupId);
      if (alive) setMeetings(m);
    })();

    return () => { alive = false; };
  }, [groupId, activityGroupId]);

  return (
    <section className='meetings'>
      <div className='meetings__main group'>
        <div className='group__info info'>
          <div className='info__icon icon'>
            <span className='material-symbols-rounded icon__img'>school</span>
          </div>
          <span className='info__title'>Tomar asistencia</span>
          <span className='info__value'>Lista de Encuentros</span>
        </div>

        {hasGroupContext && (
          <>
            <button
              type='button'
              className='group__btn group__btn--characterization btn'
              onClick={() => handleOpenTimeModal('characterization')}
              disabled={isGeneratingQr || qrMeetingIds.length === 0}>
              <span className='material-symbols-rounded btn__icon'>
                draw
              </span>
              <span className='btn__text'>Caracterizar jornada</span>
            </button>
            <button
              type='button'
              className='group__btn group__btn--qr btn'
              onClick={() => handleOpenTimeModal('qr')}
              disabled={isGeneratingQr || qrMeetingIds.length === 0}>
              <span className='material-symbols-rounded btn__icon'>
                qr_code_2
              </span>
              <span className='btn__text'>
                {isGeneratingQr ? 'Generando...' : 'Generar QR'}
              </span>
            </button>
            <button
              type='button'
              className='group__btn group__btn--qr btn'
              onClick={handleGenerateCharacterizationQr}
              disabled={isGeneratingQr}>
              <span className='material-symbols-rounded btn__icon'>
                qr_code_2
              </span>
              <span className='btn__text'>Generar QR caracterizacion</span>
            </button>
          </>
        )}
      </div>

      <div className='meetings__details'>
        {meetings?.length > 0 && meetings.map((meeting) => (
          <MeetingItem
            key={meeting.id}    
            meeting={meeting}
            listState={meetingListState}
          />
        ))}
      </div>

      <div className='meetings__actions'>
        <button
          type='button'
          className='meetings__action meetings__action--add'
          onClick={handleAddSession}
          disabled={
            (!groupId && !activityGroupId) ||
            groupClosed ||
            isAddingSession
          }>
          <span className='material-symbols-rounded' aria-hidden='true'>add</span>
          <span className='meetings__action-text'>
            {isAddingSession ? 'Agregando...' : 'Agregar sesión'}
          </span>
        </button>
        {canOpenResultsLog && (
          <button
            type='button'
            className='meetings__action meetings__action--results-log'
            onClick={() => navigate(
              `/escuelas/grupo/lista_de_encuentros/bitacora-de-resultados?groupId=${encodeURIComponent(groupId)}`,
              {
                state: {
                  ...meetingListState,
                  school: resultsLogSchool,
                  backTo: {
                    pathname: location.pathname,
                    state: meetingListState
                  }
                }
              }
            )}>
            <span className='material-symbols-rounded' aria-hidden='true'>menu_book</span>
            <span className='meetings__action-text'>Bitácora de resultados</span>
          </button>
        )}
        <button
          type='button'
          className='meetings__action meetings__action--finish'
          onClick={openFinishConfirmation}
          disabled={!hasGroupContext || groupClosed || isFinishingGroup || isCheckingResultsLog}>
          <span className='material-symbols-rounded' aria-hidden='true'>task_alt</span>
          <span className='meetings__action-text'>
            {groupFinished
              ? 'Grupo finalizado'
              : groupCancelled
                ? 'Grupo cancelado'
                : isCheckingResultsLog ? 'Verificando bitácora...' : 'Finalizar grupo'}
          </span>
        </button>
      </div>

      {showFinishConfirmation && !groupClosed && (
        <div className='meetings-qr-modal' role='dialog' aria-modal='true' aria-labelledby='finish-group-title'>
          <section className='meetings-finish-modal'>
            <h2 id='finish-group-title' className='meetings-finish-modal__title'>Finalizar grupo</h2>
            {canOpenResultsLog ? (
              <div className='meetings-finish-modal__checklist'>
                <label className='meetings-finish-modal__check'>
                  <input type='checkbox' checked={resultsLogConfirmed} disabled={isFinishingGroup}
                    onChange={event => setResultsLogConfirmed(event.target.checked)} />
                  <span>¿Está seguro que la bitácora de resultados ya está completada y actualizada?</span>
                </label>
                <label className='meetings-finish-modal__check'>
                  <input type='checkbox' checked={finalizationConfirmed} disabled={isFinishingGroup}
                    onChange={event => setFinalizationConfirmed(event.target.checked)} />
                  <span>El grupo quedará marcado como finalizado con la fecha de la última sesión realizada y no se podrán agregar más sesiones. ¿Está seguro?</span>
                </label>
              </div>
            ) : <p className='meetings-finish-modal__text'>
              El grupo quedará marcado como finalizado con la fecha de la última sesión
              realizada y no se podrán agregar más sesiones.
            </p>}
            <div className='meetings-finish-modal__actions'>
              <button
                type='button'
                className='meetings-finish-modal__secondary'
                onClick={() => setShowFinishConfirmation(false)}
                disabled={isFinishingGroup}>
                Volver
              </button>
              <button
                type='button'
                className='meetings-finish-modal__primary'
                onClick={handleFinishGroup}
                disabled={isFinishingGroup || (canOpenResultsLog && (!resultsLogConfirmed || !finalizationConfirmed))}>
                {isFinishingGroup ? 'Finalizando...' : 'Finalizar grupo'}
              </button>
            </div>
          </section>
        </div>
      )}

      {showQrTimeModal && (
        <div className='meetings-qr-modal' role='dialog' aria-modal='true'>
          <section className='meetings-qr-modal__content meetings-qr-modal__content--time'>
            <button
              type='button'
              className='meetings-qr-modal__close'
              onClick={() => setShowQrTimeModal(false)}
              aria-label='Cerrar'>
              <span className='material-symbols-rounded'>close</span>
            </button>
            <h2 className='meetings-qr-modal__title'>Seleccionar sesiones</h2>
            <form className='meetings-qr-time-form' onSubmit={handleScheduleSubmit}>
              <fieldset className='meetings-qr-time-form__meetings'>
                <legend className='meetings-qr-time-form__label'>
                  Encuentros que se van a firmar
                </legend>
                <div className='meetings-qr-time-form__meeting-list'>
                  {scheduleMeetings.map(meeting => {
                    const meetingId = Number(meeting.id);
                    return (
                      <label
                        className='meetings-qr-time-form__meeting'
                        key={meetingId}>
                        <input
                          type='checkbox'
                          checked={selectedScheduleMeetingIds.includes(meetingId)}
                          onChange={() => toggleScheduleMeeting(meetingId)}
                        />
                        <span>Encuentro {meeting.order}</span>
                      </label>
                    );
                  })}
                </div>
              </fieldset>
              <div className='meetings-qr-time-form__actions'>
                <button
                  type='button'
                  className='meetings-qr-time-form__secondary'
                  onClick={() => setShowQrTimeModal(false)}
                  disabled={isGeneratingQr}>
                  Cancelar
                </button>
                <button
                  type='submit'
                  className='meetings-qr-time-form__primary'
                  disabled={isGeneratingQr}>
                  {isGeneratingQr
                    ? scheduleAction === 'qr'
                      ? 'Generando...'
                      : 'Guardando...'
                    : scheduleAction === 'qr'
                      ? 'Generar QR'
                      : 'Continuar'}
                </button>
              </div>
            </form>
          </section>
        </div>
      )}

      {qrInfo?.url && (
        <div className='meetings-qr-modal' role='dialog' aria-modal='true'>
          <section className='meetings-qr-modal__content'>
            <button
              type='button'
              className='meetings-qr-modal__close'
              onClick={() => setQrInfo(null)}
              aria-label='Cerrar'>
              <span className='material-symbols-rounded'>close</span>
            </button>
            <h2 className='meetings-qr-modal__title'>
              {qrInfo.title || 'Generar QR'}
            </h2>
            <QrCode
              value={qrInfo.url}
              size={320}
              className='meetings-qr-modal__qr'
            />
            <div className='meetings-qr-modal__link'>
              {qrInfo.url}
            </div>
            {qrInfo.expiresAt && (
              <p className='meetings-qr-modal__expires'>
                Vigente hasta {new Date(qrInfo.expiresAt).toLocaleString('es-CO')}
              </p>
            )}
            <button
              type='button'
              className='meetings-qr-modal__copy'
              onClick={copyQrLink}>
              Copiar enlace
            </button>
          </section>
        </div>
      )}
    </section>
  );
}

function MeetingsList() {
  const location = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const initialActivity = location.state?.activity || null;
  const initialGroup = location.state?.activityGroup || null;
  const activityId =
    searchParams.get('activityId') ?? initialActivity?.idActivity ?? null;
  const groupId =
    searchParams.get('activityGroupId') ?? initialGroup?.id ?? null;
  const isSocialControlContext = Boolean(
    location.state?.controlSocialContext ||
      searchParams.get('controlSocial') === 'true'
  );

  if (isSocialControlContext) {
    return (
      <SocialControlMeetings
        activityId={activityId}
        groupId={groupId}
        initialActivity={initialActivity}
        initialGroup={initialGroup}
        renderContent={({activity, group}) => (
          <StandardMeetingsList
            socialControlContext={{activity, group}}
          />
        )}
      />
    );
  }

  return <StandardMeetingsList />;
}

export default MeetingsList;
